import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  feedbackSubmitted: false,
  loading: false,
  error: false,
};
const submitFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_FEEDBACK_SUCCESS: {
      return {
        ...state,
        feedbackSubmitted: true,
        error: false,
        loading: false,
      };
    }
    case actionTypes.SUBMIT_FEEDBACK_FAILED: {
      return {
        ...state,
        feedbackSubmitted: false,
        error: true,
        loading: false,
      };
    }
    case actionTypes.SUBMIT_FEEDBACK_STARTED: {
      return {
        ...state,
        feedbackSubmitted: false,
        error: false,
        loading: true,
      };
    }
    case actionTypes.SUBMIT_FEEDBACK_RESET: {
      return initialState;
    }
    default:
      return state;
  }
};
export default submitFeedbackReducer;
